module.exports = __webpack_public_path__ + "static/media/setup_zoom.8850cd13.png";